import "../styles/billing.css";
import { Button } from "react-bootstrap";
import NotificationHeader from "../components/NotificationHeader/NotificationHeader";
import React from "react";

const Billing = () => {
  const { user } = JSON.parse(localStorage.getItem("auth")) || { user: {} };

  const paymentPackage = user?.paymentPackage || {};
  const subscribedPackage = paymentPackage?.packageName;

  const basicUKPrice = subscribedPackage === "BasicUK" ? "6.5" : "6.5";
  const mixedEUPrice = subscribedPackage === "MixedEU" ? "8.50" : "8.50";

  const handleSubscribeClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <>
      <NotificationHeader name="Billing" />
      <div className="BillingPage">
        <div className="container">
          <div className="pageStyle">
            <div className="row align-items-center">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="">
                  <div className="simCard mb-5">
                    <p className="titel">Basic UK Sims</p>
                    <p className="price">${basicUKPrice}</p>
                    <p className="desc">Per Line Per Month</p>
                    <Button
                      className="primaryBtn"
                      type="button"
                      onClick={() =>
                        handleSubscribeClick(
                          subscribedPackage === "BasicUK"
                            ? "https://buy.stripe.com/eVacNDgPj2Vg1yg28a"
                            : ""
                        )
                      }
                    >
                      {subscribedPackage === "BasicUK"
                        ? "Subscribed"
                        : "Subscribe"}
                    </Button>
                  </div>
                  <div className="simCard">
                    <p className="titel">Mixed EU Sims</p>
                    <p className="price">${mixedEUPrice}</p>
                    <p className="desc">Per Line Per Month</p>
                    <Button
                      className="primaryBtn"
                      type="button"
                      onClick={() =>
                        handleSubscribeClick(
                          subscribedPackage === "MixedEU"
                            ? ""
                            : "https://buy.stripe.com/bIYdRH6aF0N80uc001"
                        )
                      }
                    >
                      {subscribedPackage === "MixedEU"
                        ? "Subscribed"
                        : "Subscribe"}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                {/* Removed renewal date, renewal amount, and manage subscription button */}
                {/* <div className="billingRightSide">
                  {subscribedPackage && (
                    <>
                      <p className="renewalDate">
                        Renewal Date
                        <span>{new Date().toISOString().split("T")[0]}</span>
                      </p>
                      <p className="renewalDate">
                        Renewal Amount
                        <span>
                          $
                          {subscribedPackage === "BasicUK"
                            ? basicUKPrice
                            : mixedEUPrice}
                        </span>
                      </p>
                    </>
                  )}
                  <button
                    className="primaryBtn"
                    type="button"
                    onClick={() =>
                      handleSubscribeClick("https://www.google.com")
                    }
                  >
                    Manage Subscriptions
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Billing;
